import { SectionBody } from "../../section-layout";

const SK =
  "shimmer shimmer-bg text-foreground rounded bg-contrast/8";

function JobRowSkeleton() {
  return (
    <div className="flex w-full items-center gap-6 overflow-clip rounded-lg border border-border/50 bg-contrast/1 p-3 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <div className="flex items-center gap-1.5 px-1">
          <div className={`${SK} h-3.5 w-32`} />
          <span className="size-1 shrink-0 rounded-full bg-contrast/15" />
          <div className={`${SK} h-3.5 w-16 !rounded-full`} />
        </div>
        <div className="flex items-center gap-1.5 px-1">
          <div className={`${SK} size-[14px] shrink-0`} />
          <div className={`${SK} h-3 w-36`} />
          <span className="size-1 shrink-0 rounded-full bg-contrast/15" />
          <div className={`${SK} h-3 w-20`} />
        </div>
      </div>

      <div className={`${SK} size-4 shrink-0`} />
    </div>
  );
}

export function JobsPending() {
  return (
    <SectionBody className="gap-2">
      <JobRowSkeleton />
      <JobRowSkeleton />
    </SectionBody>
  );
}
